
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { UnifiedLoader } from '@/components/dashboard/shared/UnifiedLoader';

const BecomePractitioner: React.FC = () => {
  const { user, activeRole, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) return;

    if (user) {
      // User is logged in, redirect based on role
      if (activeRole === 'practitioner') {
        navigate('/practitioner-dashboard');
      } else if (activeRole === 'client') {
        navigate('/client-dashboard');
      } else {
        // User has no specific role, redirect to practitioner auth for registration
        navigate('/practitioner-auth');
      }
    } else {
      // User is not logged in, redirect to practitioner registration
      navigate('/practitioner-auth');
    }
  }, [user, activeRole, isLoading, navigate]);

  // Show loading while checking auth status
  return <UnifiedLoader message="Redirecting..." fullScreen />;
};

export default BecomePractitioner;
